import React from 'react';
import PropTypes from 'prop-types';

import VenueIcon from 'material-ui/svg-icons/communication/location-on';

const style = {
    icon: {
        margin:  0,
        padding: 0,
        height:  '32px',
        width:   '32px',
        bottom:      0,
        left:     0,
        position: 'absolute',
    }
};
const iconColour = 'rgb(35, 151, 190)';

const Marker = (props) => (
    <div key="marker" className="mapMarker" >
        <div className="mapMarker-icon">
            <VenueIcon
                style={style.icon}
                color={iconColour} />
        </div>
        <div className="mapMarker-title">{props.title}</div>
    </div>
);

Marker.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
};

Marker.defaultProps = ({
    title: '',
    description: ''
});

export default Marker;